import green from "@material-ui/core/colors/green"
const styles = theme => ({
  buttonGroup: {
    marginRight: theme.spacing(2),
  },
  detailsContainer: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexWrap: "wrap",
      padding: "32px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 10,
    },
    backgroundColor: "#f8f8f8",
  },
  selected: {
    fontWeight: "600",
    fontSize: "0.8rem",
  },
  unselected: {
    color: "grey",
    fontSize: "0.8rem",
  },
  datePicker: {
    width: 325,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  timePicker: {
    width: 325,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      marginLeft: "32px",
      position: "relative",
      overflow: "visible",
    },
  },
  timezonePicker: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
    position: "absolute",
    right: 0,
    [theme.breakpoints.down("sm")]: {
      right: 20,
    },
  },
  timezonePickerBasic: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    right: 0,
    [theme.breakpoints.down("sm")]: {
      right: 20,
    },
  },
  card: {
    overflow: "initial",
    marginBottom: theme.spacing(2),
  },
  additionalGearWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  inputWrapper: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: theme.spacing(1),
  },
  autoComplete: {
    flexGrow: 1,
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  locationAutoComplete: {
    marginTop: 16,
  },
  saveButton: {
    position: "fixed",
    bottom: 32,
    right: 32,
  },
  closeIcon: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
  },
  closeAvatar: {
    backgroundColor: "white",
    border: `2px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
  },
  chipBlue: {
    backgroundColor: theme.palette.primary.main,
  },
  chipGrey: {
    backgroundColor: "#9e9e9e",
  },
  chipPurple: {
    backgroundColor: "#966dd3",
  },
  chipYellow: {
    backgroundColor: "#FFB60C",
    cursor: "pointer",
  },
  chipGreen: {
    backgroundColor: green[400],
    cursor: "pointer",
  },
  chipRed: {
    backgroundColor: theme.palette.secondary.main,
    cursor: "pointer",
  },
  detailTypography: {
    marginBottom: theme.spacing(1),
  },
  detailWrapper: {
    marginBottom: theme.spacing(2),
  },
  mapImage: {
    width: "100%",
  },
  location: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },

  representativeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "underline",
    cursor: "pointer",
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
    marginRight: theme.spacing(1),
  },
  shootName: {
    cursor: "pointer",
  },
  editIcon: {
    position: "relative",
    top: 2,
    marginLeft: theme.spacing(1),
  },
  editNameTextField: {
    marginRight: theme.spacing(1),
  },
  editNameTextFieldWeb: {
    marginRight: theme.spacing(1),
    width: "100%",
  },
  rateWrapper: {
    flexGrow: 1,
    // textAlign: "right",
    display: "flex",
    // justifyContent: "flex-end",
    alignItems: "baseline",
  },
  rateHeadline: {
    color: "grey",
    fontSize: "0.7rem",
    // fontFamily: "Oswald",
  },
  rate: {
    // color: "grey",
    // fontFamily: "Oswald",
  },
  dialogTitle: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  closeButton: {
    width: 28,
    height: 28,
  },
  overlay: {
    position: "absolute",
    display: "block",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 2,
  },
  crewCardWrapper: {
    // marginBottom: theme.spacing(2),
    width: "100%",
    position: "relative",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  positionText: {
    fontSize: "0.7rem",
    fontWeight: 800,
  },
  marginLeft: {
    marginLeft: theme.spacing(5),
  },
  iconButton: {
    color: theme.palette.primary.main,
  },
  crewWrapper: {
    height: "fit-content",
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  basicInfoWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
    },
  },
  shootInfoWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
    },
  },
  postionSlide: {
    [theme.breakpoints.down("sm")]: {
      width: "95%",
    },
  },
  actionButton: {
    fontSize: "0.7rem",
    fontWeight: 600,
  },
  newInputWrapper: {
    flexGrow: "1",
    flexWrap: "none",
  },
  legendButton: {
    position: "fixed",
    bottom: "200px",
    right: "20px",
    zIndex: 5,
  },
  collapseStyles: {
    boxShadow: "none",
    border: "none",
    width: "100%",
    padding: "0",
    backgroundColor: "transparent",
  },
  collapseSummary: {
    width: "100%",
    justifyContent: "space-between",
    margin: 0,
    display: "flex",
    padding: 0,
  },
  collapseDetails: {
    padding: "0px",
    width: "100%",
    backgroundColor: "#ffffff",
    display: "flow-root",
  },
  collapseDetailsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  collapseDetailsRow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    padding: "10px",
    alignItems: "center",
  },
  collapseDetailsLastRow: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  collapseSummaryRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  icons: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.grey[400],
    justifyContent: "space-between",
    width: "80px",
  },
  trigger: {
    cursor: "pointer",
  },
  iconDisabled: {
    color: theme.palette.grey[200],
    cursor: ["default", "!important"],
  },
  modal: {
    position: "absolute",
    width: "50%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: "none",
    [theme.breakpoints.down("md")]: {
      width: "65%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  boxIcon: {
    fontSize: "1.3em",
  },
  popover: {
    pointerEvents: "none",
  },
  popoverPaper: {
    padding: theme.spacing(2),
  },
  popoverTitle: {
    fontWeight: 600,
  },
  listItem: {
    padding: [0, "!important"],
  },
  listText: {
    color: "rgba(0,0,0,0.35)",
  },
  vehicleIcon: {
    fontSize: "1.1em",
  },
})

export default styles
